import { ClassProvider, Injectable } from '@angular/core';
import { Translation, TRANSLOCO_LOADER, TranslocoLoader } from '@ngneat/transloco';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string) {
        return this.http.get<Translation>(`./assets/i18n/${lang}.json`);
    }
}

export const provideTranslocoLoader: ClassProvider = { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader };
